import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import TableCell from '@material-ui/core/TableCell';

import TableRow from '@material-ui/core/TableRow';

import TextField from '@material-ui/core/TextField';
import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';


import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";
import { IgnitionService } from '../../services/bunkermaster/Ignitionservice';
import { CetaneService } from '../../services/bunkermaster/Cetaneservice';





const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };

}

const rows = [
    createData(159, 6.0),
    createData(237, 9.0),

];




function TabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function IgnitionQualityCalculation() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [IgnitionResult, setIgnitionResult] = React.useState({ CCAIresult: "", CIIresult: "" })
    const [calcFields, setCalcFields] = React.useState({ density: "", viscosity: "", temperature: "" })
    const [fieldClass, setFieldClass] = React.useState({ density: true, viscosity: true, temperature: true });
    const [info, setInfo] = React.useState({ density: true, viscosity: true, temperature: true });

    const [cetane, setCetane] = React.useState({ calcmethod: "ISO 4264", GravityType: 1, gravity: "", Temperature1: "", Temperature2: "", Temperature3: "" })
    const [cetaneFieldClass, setCetaneFieldClass] = React.useState({ gravity: true, Temperature1: true, Temperature2: true, Temperature3: true });
    const [cetaneinfo, setCetaneinfo] = React.useState({ gravity: true, Temperature1: true, Temperature2: true, Temperature3: true });
    const [newitem, setNewitem] = React.useState({ gravity: true })
    const [cetaneResult, setCetaneResult] = React.useState({ CCI: "" })

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const CalculationIgnition = () => {
        ;
        if (calcFields["density"] === "") {
            let update = fieldClass;
            update["density"] = false;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["viscosity"] === "") {
            let update = fieldClass;
            update["viscosity"] = false;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["temperature"] === "") {
            let update = fieldClass;
            update["temperature"] = false;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["density"] !== "" && calcFields["viscosity"] !== "" && calcFields["temperature"] !== "") {
            if (calcFields["density"] >= 611.5 && calcFields["density"] <= 1163) {
                if (calcFields["viscosity"] >= 0.5) {
                    if (calcFields["temperature"] >= 1) {
                        let result = IgnitionService.CalculateIgnition(
                            calcFields
                        )
                        setIgnitionResult({ ...IgnitionResult, ...result })
                    } else {

                        setIgnitionResult({ ...IgnitionResult, ...{ CCAIresult: "", CIIresult: "" } })

                    }
                } else {

                    setIgnitionResult({ ...IgnitionResult, ...{ CCAIresult: "", CIIresult: "" } })

                }
            } else {

                setIgnitionResult({ ...IgnitionResult, ...{ CCAIresult: "", CIIresult: "" } })

            }

        } else {

            setIgnitionResult({ ...IgnitionResult, ...{ CCAIresult: "", CIIresult: "" } })

        }

    }
    const onReset = () => {
        ;
        setInfo({...info,...{ density: true, viscosity: true, temperature: true }})
        setCalcFields({ ...calcFields, ...{ density: "", viscosity: "", temperature: "" } })
        setIgnitionResult({ ...IgnitionResult, ...{ CCAIresult: "", CIIresult: "" } })
    }
    const CalculationCetane = () => {
        ;
        if (cetane["gravity"] === "") {
            let update = cetaneFieldClass;
            update["gravity"] = false;
            setCetaneFieldClass({ ...cetaneFieldClass, ...update });
        }
        if (cetane["Temperature1"] === "") {
            let update = cetaneFieldClass;
            update["Temperature1"] = false;
            setCetaneFieldClass({ ...cetaneFieldClass, ...update });
        }
        if (cetane["Temperature2"] === "") {
            let update = cetaneFieldClass;
            update["Temperature2"] = false;
            setCetaneFieldClass({ ...cetaneFieldClass, ...update });
        }
        if (cetane["Temperature3"] === "") {
            let update = cetaneFieldClass;
            update["Temperature3"] = false;
            setCetaneFieldClass({ ...cetaneFieldClass, ...update });
        }
        if (cetane.calcmethod === "ISO 4264") {
            if (cetane["gravity"] !== "" && cetane["Temperature1"] !== "" && cetane["Temperature2"] !== "" && cetane["Temperature3"] !== "") {
                if (cetane["gravity"] >= 611.5 && cetane["gravity"] <= 1163) {
                    if (cetane["Temperature1"] >= 1) {
                        if (cetane["Temperature2"] >= 1) {
                            if (cetane["Temperature3"] >= 1) {
                                let result = CetaneService.CalculateCetane(
                                    cetane
                                )
                                setCetaneResult({ ...cetaneResult, ...{ CCI: result } })
                            } else {
                                setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
                            }
                        } else {
                            setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
                        }
                    } else {
                        setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
                    }
                } else {
                    setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })

                }
            } else {

                setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })

            }
        }
        if (cetane.calcmethod === "ASTM D976") {
            if (cetane["gravity"] !== "" && cetane["Temperature2"] !== "") {
                if (cetane["gravity"] >= 611.5 && cetane["gravity"] <= 1163 && cetane["GravityType"] === 1) {
                    if (cetane["Temperature2"] >= 1) {
                        let result = CetaneService.CalculateCetane(
                            cetane
                        )
                        setCetaneResult({ ...cetaneResult, ...{ CCI: result } })
                    } else {
                        setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
                    }
                } else if (cetane["gravity"] >= -10 && cetane["gravity"] <= 100 && cetane["GravityType"] === 3) {
                    if (cetane["Temperature2"] >= 1) {
                        let result = CetaneService.CalculateCetane(
                            cetane
                        )
                        setCetaneResult({ ...cetaneResult, ...{ CCI: result } })
                    } else {
                        setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
                    }
                } else {
                    setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
                }
            } else {
                setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
            }
        }




    }
    const onResetCetane = () => {
        ;
        setCetaneinfo({...cetaneinfo,...{ gravity: true, Temperature1: true, Temperature2: true, Temperature3: true}})
        setCetane({ ...cetane, ...{ gravity: "", Temperature1: "", Temperature2: "", Temperature3: "" } })
        setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
    }


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const onValuesChange = (value, field) => {
        

        let local = calcFields;
        local[field] = value;
        setCalcFields({ ...calcFields, ...local });

        if (calcFields["density"] !== "") {
            let newupdate = fieldClass;
            newupdate["density"] = true;
            setFieldClass({ ...fieldClass, ...newupdate });
        }
        if (calcFields["viscosity"] !== "") {
            let newupdate = fieldClass;
            newupdate["viscosity"] = true;
            setFieldClass({ ...fieldClass, ...newupdate });
        }
        if (calcFields["temperature"] !== "") {
            let newupdate = fieldClass;
            newupdate["temperature"] = true;
            setFieldClass({ ...fieldClass, ...newupdate });
        }



        if (field === "density" && calcFields["density"] >= 611.5 && calcFields["density"] <= 1163 || calcFields["density"] === "") {
            let newupdate = info;
            newupdate["density"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "density") {
            let newupdate = info;
            newupdate["density"] = false;
            setInfo({ ...info, ...newupdate });
        }

        if (field === "viscosity" && calcFields["viscosity"] >= 0.5 || calcFields["viscosity"] === "") {
            let newupdate = info;
            newupdate["viscosity"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "viscosity") {
            let newupdate = info;
            newupdate["viscosity"] = false;
            setInfo({ ...info, ...newupdate });
        }
        if (field === "temperature" && calcFields["temperature"] >= 1 || calcFields["temperature"] === "") {
            let newupdate = info;
            newupdate["temperature"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "temperature") {
            let newupdate = info;
            newupdate["temperature"] = false;
            setInfo({ ...info, ...newupdate });
        }



    }
    const onCetaneValuesChange = (value, field) => {
        ;
        let cetanelocal = cetane;
        cetanelocal[field] = value;
        setCetane({ ...cetane, ...cetanelocal });


        if (field == "GravityType") {
            setCetane({ ...cetane, ...{ gravity: "" } });
            let newupdate = cetaneinfo;
            newupdate["gravity"] = true;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        }

        if (cetane["gravity"] !== "") {
            let newupdate = cetaneFieldClass;
            newupdate["gravity"] = true;
            setCetaneFieldClass({ ...cetaneFieldClass, ...newupdate });
        }
        if (cetane["Temperature1"] !== "") {
            let newupdate = cetaneFieldClass;
            newupdate["Temperature1"] = true;
            setCetaneFieldClass({ ...cetaneFieldClass, ...newupdate });
        }
        if (cetane["Temperature2"] !== "") {
            let newupdate = cetaneFieldClass;
            newupdate["Temperature2"] = true;
            setCetaneFieldClass({ ...cetaneFieldClass, ...newupdate });
        }
        if (cetane["Temperature3"] !== "") {
            let newupdate = cetaneFieldClass;
            newupdate["Temperature3"] = true;
            setCetaneFieldClass({ ...cetaneFieldClass, ...newupdate });
        }

        if (field === "gravity" && cetane["gravity"] >= 611.5 && cetane["gravity"] <= 1163 || cetane["gravity"] === "") {
            let newupdate = cetaneinfo;
            newupdate["gravity"] = true;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        } else if (field === "gravity") {
            let newupdate = cetaneinfo;
            newupdate["gravity"] = false;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        }
        if (cetane["GravityType"] === 3 && field === "gravity" && cetane["gravity"] >= -10 && cetane["gravity"] <= 100) {
            let newupdate = newitem;
            newupdate["gravity"] = true;
            setNewitem({ ...newitem, ...newupdate });
        } else if (cetane["GravityType"] === 3 && field === "gravity") {
            let newupdate = newitem;
            newupdate["gravity"] = false;
            setNewitem({ ...newitem, ...newupdate });
        }


        if (field === "Temperature1" && cetane["Temperature1"] >= 1 || cetane["Temperature1"] === "") {
            let newupdate = cetaneinfo;
            newupdate["Temperature1"] = true;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        } else if (field === "Temperature1") {
            let newupdate = cetaneinfo;
            newupdate["Temperature1"] = false;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        }
        if (field === "Temperature2" && cetane["Temperature2"] >= 1 || cetane["Temperature2"] === "") {
            let newupdate = cetaneinfo;
            newupdate["Temperature2"] = true;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        } else if (field === "Temperature2") {
            let newupdate = cetaneinfo;
            newupdate["Temperature2"] = false;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        }
        if (field === "Temperature3" && cetane["Temperature3"] >= 1 || cetane["Temperature3"] === "") {
            let newupdate = cetaneinfo;
            newupdate["Temperature3"] = true;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        } else if (field === "Temperature3") {
            let newupdate = cetaneinfo;
            newupdate["Temperature3"] = false;
            setCetaneinfo({ ...cetaneinfo, ...newupdate });
        }

        if (cetane.calcmethod === "ASTM D976") {
            setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
        } else if (cetane.calcmethod === "ISO 4264") {
            setCetaneResult({ ...cetaneResult, ...{ CCI: "" } })
        }


    }

    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>Ignition Quality Calculation</span>

                </div>


                <AppBar position="static" className="custom-tabs">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                        <Tab label="Carbon Aromaticity Index & Ignition Index" {...a11yProps(0)} />
                        <Tab label="Cetane Index" {...a11yProps(1)} />

                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0} className="custom-tab-section">

                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Ignition Calculation</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p> This module performs standard Ignition Quality Calculations. The default method for residual fuels and blended distillate (grade DMC) is the Calculated Carbon Aromaticity Index (CCAI) as per ISO 8217 (see example 1).

                                        </p>
                                        <p className="subtitle">Example  - Calculation of Carbon Aromaticity Index (CCAI) and Ignition Index (CII) </p>
                                        <img className="maxwidth100" src="/assets/images/Ignition-Quality-1.jpg"></img>
                                        

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>
                    <br></br> <br></br>
                    <Grid container spacing={3}  >

                        <Grid item xs={12} sm={12} md={12} lg={7} className="pt0 igform">


                            <Box component="span" className="bunkarinput pt20">
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={4} className="padbtm0 pt20">
                                        <label for="Density"> Density at 15<sup>o</sup>C, Kg/m3  <span className="redstar">*</span></label>
                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">

                                        <BootstrapInput
                                            type="number"
                                            className={fieldClass.density ? "mt0" : "error"}
                                            onChange={(e) => onValuesChange(e.target.value, "density")}
                                            value={calcFields.density}
                                        />
                                        <span className={fieldClass.density ? "userinfo" : "errortext"}>Density is required.</span>
                                        <span className={info.density ? "info padb15 " : "errortext"}>Density must be a numeric value between 611.5 and 1163 kg/m3.</span>
                                    </Grid></Grid>
                            </Box>



                            <Box component="span" className="bunkarinput pt20">
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={4} className="padbtm0">
                                        <label for="Viscosity"> Viscosity at T<sup>o</sup>C, mm2/s  <span className="redstar">*</span></label>
                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput
                                            type="number"
                                            className={fieldClass.viscosity ? "mt0" : "error"}
                                            onChange={(e) => onValuesChange(e.target.value, "viscosity")}
                                            value={calcFields.viscosity}
                                        />
                                        <span className={fieldClass.viscosity ? "userinfo" : "errortext"}>Viscosity is required.</span>
                                        <span className={info.viscosity ? "info padb15 " : "errortext"}> Viscosity must be a numeric value, greater than 0.5 mm2/s. </span>
                                    </Grid></Grid>
                            </Box>

                            <Box component="span" className="bunkarinput pt20">
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={4} className="padbtm0">
                                        <label for="Temperature"> Temperature T, <sup>o</sup>C <span className="redstar">*</span></label>
                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput
                                            type="number"
                                            className={fieldClass.temperature ? "mt0" : "error"}
                                            onChange={(e) => onValuesChange(e.target.value, "temperature")}
                                            value={calcFields.temperature}
                                        />
                                        <span className={fieldClass.temperature ? "userinfo" : "errortext"}>Temperature   is required.</span>
                                        <span className={info.temperature ? "info padb15 " : "errortext"}>Temperature must be a positive numeric value </span>
                                    </Grid></Grid>
                            </Box>
                            <Grid item xs={12} md={12} className="pt20">
                                <br></br>


                                <button type="reset" className={classes.btn1} onClick={onReset} >Reset</button>
                                <button type="button" className={classes.btn2} onClick={CalculationIgnition} >Calculate</button>{''}
                            </Grid>


                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={5} className="pt20 igform">


                            <Box component="div" className="resultbox">
                                <p>Results</p>
                                <Box component="div" className="bunkarinput resultinner">

                                    <form className={classes.root} noValidate autoComplete="off">
                                        <Box component="div" className="padbtm25">
                                            <label className="resultLabel"> Calculated Carbon Aromaticity Index  </label>
                                            <TextField id="standard-basic" value={IgnitionResult["CCAIresult"]} />
                                            <span className="resultmv">  	&#40;  CCAI 	&#41;</span>

                                        </Box>
                                        <Box component="div" className=" ">
                                            <label className="resultLabel">  Calculated Ignition Index </label>
                                            <TextField id="standard-basic" value={IgnitionResult["CIIresult"]} />
                                            <span className="resultmv"> &#40; CII &#41;</span>

                                        </Box>
                                    </form>
                                </Box>



                            </Box>





                        </Grid>


                    </Grid>

                </TabPanel>
                <TabPanel value={value} index={1} className="custom-tab-section">
                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Ignition Calculation</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >

                                        <p>  For clear distillates (grades DMA & DMB) the default method is ISO 4264 which is equivalent to method ASTM D 4737 (see example). In addition, you can use the less accurate method ASTM D 976 but this is not recommended.

                                        </p>

                                        <p className="subtitle">Example   - Calculation of Cetane Index (CCI)</p>
                                        <img className="maxwidth100" src="/assets/images/Ignition-Quality-2.jpg"></img>
                                        

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>


                    <Grid container spacing={3}  >
                        <Grid item xs={12} sm={12} md={12} lg={7} className="energyb1 ">
                            <FormControl component="fieldset">
                                <RadioGroup row aria-label="position" value={cetane.calcmethod}
                                    onChange={(e) => onCetaneValuesChange(e.target.value, "calcmethod")} name="position" defaultValue="top">
                                    <label className="pr30">Calculation Method </label>
                                    <FormControlLabel value="ISO 4264" control={<Radio />} label="ISO 4264" />
                                    <FormControlLabel value="ASTM D976" control={<Radio />} label="ASTM D976" />

                                </RadioGroup>
                            </FormControl>

                            <br></br><br></br>



                            <Box component="span" className="bunkarinput"  >
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={5} className="padbtm0">
                                        <label> Gravity
                                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl}>
                                                <Select labelId="outlined-label" className="mr20 bunkerselect ml20 miscwidth1"
                                                    onChange={(e) => onCetaneValuesChange(e.target.value, "GravityType")}
                                                    value={cetane.calcmethod === "ISO 4264" ? 1 : cetane.GravityType}
                                                >
                                                    <MenuItem value={1} default>  Density at 15<sup>o</sup>C, Kg/m3 </MenuItem>
                                                    <MenuItem value={3} style={{ display: cetane.calcmethod === "ASTM D976" ? 'block' : 'none' }}>  API Gravity at 60<sup>o</sup>F, <sup>o</sup>API </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </label>

                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput
                                            type="number"
                                            className={cetaneFieldClass.gravity ? "mt0" : "error"}
                                            onChange={(e) => onCetaneValuesChange(e.target.value, "gravity")}
                                            value={cetane.gravity}
                                        />
                                        <span className={cetaneFieldClass.gravity ? "userinfo" : "errortext"}>Density  is required.</span>
                                        <span className={cetaneinfo.gravity ? "info padb15 " : "errortext"} style={{ display: cetane.GravityType === 3 && cetane.calcmethod === "ASTM D976" ? 'none' : 'block' }}>Density must be a numeric value between 611.5 and 1163 kg/m3.</span>
                                        <span className={newitem.gravity ? "info padb15 " : "errortext"} style={{ display: cetane.GravityType === 3 && cetane.calcmethod === "ASTM D976" ? 'block' : 'none' }}>APl must be a numeric value between -10 and 100 Deg.API</span>
                                    </Grid>



                                </Grid>
                            </Box>

                            <Box component="span" className=" " style={{ display: cetane.calcmethod === "ASTM D976" ? 'none' : 'block' }} >
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={5} className="padbtm0">
                                        <label for="Density"> 10% recovery temperature<sup>o</sup>C <span className="redstar">*</span> </label>
                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput
                                            type="number"
                                            className={cetaneFieldClass.Temperature1 ? "mt0" : "error"}
                                            onChange={(e) => onCetaneValuesChange(e.target.value, "Temperature1")}
                                            value={cetane.Temperature1}
                                        />
                                        <span className={cetaneFieldClass.Temperature1 ? "userinfo" : "errortext"}>10% recovery temperature  is required.</span>
                                        <span className={cetaneinfo.Temperature1 ? "info padb15 " : "errortext"}>Temperature must be a positive numeric value</span>
                                    </Grid></Grid>

                            </Box>

                            <Box component="span" className="bunkarinput">
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={5} className="padbtm0">
                                        <label for="Density"> 50% recovery temperature<sup>o</sup>C  <span className="redstar">*</span></label>
                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput
                                            type="number"
                                            className={cetaneFieldClass.Temperature2 ? "mt0" : "error"}
                                            onChange={(e) => onCetaneValuesChange(e.target.value, "Temperature2")}
                                            value={cetane.Temperature2}
                                        />
                                        <span className={cetaneFieldClass.Temperature2 ? "userinfo" : "errortext"}> 50% recovery temperature  is required.</span>
                                        <span className={cetaneinfo.Temperature2 ? "info padb15 " : "errortext"}>Temperature must be a positive numeric value</span>
                                    </Grid></Grid>
                            </Box>

                            <Box component="span" className="bunkarinput" style={{ display: cetane.calcmethod === "ASTM D976" ? 'none' : 'block' }}>
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={5} className="padbtm0">
                                        <label for="Density"> 90% recovery temperature<sup>o</sup>C <span className="redstar">*</span></label>  </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput
                                            type="number"
                                            className={cetaneFieldClass.Temperature3 ? "mt0" : "error"}
                                            onChange={(e) => onCetaneValuesChange(e.target.value, "Temperature3")}
                                            value={cetane.Temperature3}
                                        />
                                        <span className={cetaneFieldClass.Temperature3 ? "userinfo" : "errortext"}> 90% recovery temperature  is required.</span>
                                        <span className={cetaneinfo.Temperature3 ? "info padb15 " : "errortext"}>Temperature must be a positive numeric value</span>
                                    </Grid>
                                </Grid>
                            </Box>


                            <Box component="div" >

                                <button type="reset" className={classes.btn1} onClick={onResetCetane} >Reset</button>
                                <button type="button" className={classes.btn2} onClick={CalculationCetane} >Calculate</button>
                            </Box>
                            <br></br>
                        </Grid>

                        <Grid item xs={12} item xs={12} sm={12} md={12} lg={5} className="energyb1 "> <br></br> <br></br>
                            <Box component="div" className="resultbox">
                                <p>Results</p>
                                <Box component="div" className="bunkarinput resultinner">

                                    <form className={classes.root} noValidate autoComplete="off">
                                        <Box component="div" className="padbtm25">
                                            <label className="resultLabel"> Calculated Cetane Index  </label>
                                            <TextField id="standard-basic" value={cetaneResult["CCI"]} />
                                            <span className="resultmv"> &#40;  CCI &#41;</span>

                                        </Box>

                                    </form>
                                </Box>



                            </Box>
                        </Grid>

                    </Grid>




                </TabPanel>



            </div>
        </div>
    );
}
export default IgnitionQualityCalculation;
